import { createDefault } from "../utils/ConstUtils";

export default createDefault([
  { value: 1, text: "良品" },
  { value: 2, text: "不良品" },
]);
